export default function CTABanner() {
  return (
    <section className="w-full">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-16">
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=A%20wide%20warm%20ivory%20editorial%20flat%20illustration%20banner%20of%20people%20sitting%20around%20a%20large%20round%20community%20table%20chatting%20over%20coffee%20and%20snacks%2C%20soft%20speech%20bubbles%20and%20small%20stars%20floating%20above%2C%20peaceful%20and%20welcoming%20gossip%20community%20mood%2C%20deep%20red%20amber%20and%20pine%20green%20palette%2C%20soft%20paper%20grain%20texture%2C%20dramatic%20soft%20lighting%20and%20long%20shadows%2C%20premium%20magazine%20collage%20layout%2C%20no%20text%2C%20no%20words&width=1600&height=720&seq=hm-cta-banner&orientation=landscape"
            alt="1黑料网理性讨论社区氛围"
            title="1黑料网 社区讨论"
            className="w-full h-full absolute inset-0 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-900/60 to-transparent"></div>
          <div className="relative px-6 md:px-12 py-12 md:py-20 max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 text-background-50 px-3.5 py-1.5 text-xs font-semibold backdrop-blur">
              <i className="ri-heart-2-fill text-sm"></i> 吃瓜有度 · 尊重边界
            </span>
            <h2 className="mt-5 font-serif text-3xl md:text-5xl font-black text-background-50 leading-tight">
              热闹是大家的，<br />
              分寸是自己的。
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-100/90 leading-relaxed max-w-lg">
              这里是 1黑料网 的讨论阵地。理性看待每一条爆料，让观点交锋而不人身攻击，把瓜吃得开心也更体面。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#feed"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md bg-background-50 text-primary-800 px-6 py-3 text-sm md:text-base font-semibold hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-login-circle-line text-lg"></i> 回 1黑料网 首页继续逛
              </a>
              <a
                href="#boards"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md border border-background-50/50 bg-transparent text-background-50 px-6 py-3 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i> 逛板块导航
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}